import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store';
import ggAuth from 'ggApp/modules/auth';
import React from 'react';
import PaymentsModuleContext, {
    PaymentsModuleContextType,
} from 'ggApp/shared/screens/PaymentMethods/PaymentsModuleContext/PaymentsModuleContext';

export const PaymentsModuleWrap = ({ component, ...rest }: { component: any }) => {
    const Component = component;
    return (
        <PaymentsModuleContext.Provider value={{ ...(rest as PaymentsModuleContextType) }}>
            <Component {...rest} />
        </PaymentsModuleContext.Provider>
    );
};

export const PaymentsModuleConnectedWrap: any = connect(
    createStructuredSelector({
        activeStore: activeStoreSelector,
        user: ggAuth.selectors.user,
    }),
    (dispatch) => ({
        dispatch,
    }),
)(PaymentsModuleWrap as any);
